// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n0Vh","newExpiryDate":"styles_newExpiryDate__3C9g_","footer":"styles_footer__zjfkT"};